import { SuccessComponent } from './success/success.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { PaymentComponent } from './payment/payment.component';
import { RoomsComponent } from './rooms/rooms.component';
import { SearchBodyComponent } from './search-body/search-body.component';
import { CompanyComponent } from './company/company.component';
import { ErrorComponent } from './error/error.component';

const routes: Routes = [
  { path: 'company/:company', component: CompanyComponent,
    children: [
      { path: '', redirectTo: 'search', pathMatch: 'full' },
      { path: 'search', component: SearchBodyComponent },    
      { path: 'rooms', component: RoomsComponent },
      { path: 'payment', component: PaymentComponent},
      { path: 'success', component: SuccessComponent },   
      { path: 'error', component: ErrorComponent },   
      { path: 'search', redirectTo: 'search', pathMatch: 'full' },
      { path: '**', redirectTo: 'search', pathMatch: 'full' },    
    ] 
  },
  { path: 'error', component: ErrorComponent },
  { path: 'company/error', redirectTo: 'error', pathMatch: 'full' },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    //RouterModule.forRoot(routes, { enableTracing: true }),
    RouterModule.forRoot(routes),
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
